import router from './router'
import store from './store'
import { Notify } from 'vant'
import { getToken } from '@/utils/auth' // getToken from cookie
import { getUrlParam } from '@/utils/index'

const whiteList = ['/login', '/Error']

router.beforeEach(async (to, from, next) => {
  // determine if there has token
  const accessToken = getToken()
  if (accessToken) {
    /* has token*/
    // 判断当前用户是否已拉取完user_info信息
    const userId = store.getters.id
    if (userId) {
      next()
    } else {
      try {
        // 拉取user_info
        await store.dispatch('user/GetInfo')
        next()
      } catch (error) {
        Notify({
          type: 'danger',
          message: '登录失败',
          duration: 2000
        })
        next({ path: '/Error' })
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      // 拉取user_info
      await store.dispatch('user/GetInfo')
      next()
    } else {
      /* has no token*/
      const token = getUrlParam('token')
      if (token) {
        try {
          await store.dispatch('user/loginByAppToken', token)
          // 拉取user_info
          await store.dispatch('user/GetInfo')
          next()
        } catch (error) {
          Notify({
            type: 'danger',
            message: '登录失败',
            duration: 2000
          })
          next({ path: '/Error' })
        }
      } else {
        Notify({
          type: 'danger',
          message: '登录失败',
          duration: 2000
        })
        next({ path: '/login' })
      }
    }
  }
})

router.afterEach(() => {
  // finish progress bar
})
